<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="maintenanceEventShortTermRentals" [lazy]="true" (onLazyLoad)="loadLazy($event)"
  dataKey="shortTermRentalId" selectionMode="single" [(selection)]="maintenanceEventShortTermRental"
  (onRowSelect)="onRowSelect($event)" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h6 style="text-align: left;">Maintenance Event Short Term Rentals</h6>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new-->
        <!-- <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
      (click)="onOpenFormAdd()">New Maintenance Event Short Term Rental +</button> -->
    </span>
  </div>
</ng-template>
<ng-template pTemplate="header">
  <tr>
    @for (col of columns; track col) {
      <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>
    }
    <th [ngStyle]="{'width': 'auto'}"></th>
  </tr>
  @if (showFilter) {
    <tr>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalId', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'propertyCode', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'opsNote', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'createDate', 'in')"></th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
  }
</ng-template>
<ng-template pTemplate="body" let-maintenanceEventShortTermRental>
  @if (maintenanceEventId && (maintenanceEventId == maintenanceEventShortTermRental.maintenanceEventId)) {
    <tr
      [pSelectableRow]="maintenanceEventShortTermRental">
      <td>{{maintenanceEventShortTermRental.shortTermRentalId}} </td>
      <td>{{maintenanceEventShortTermRental.propertyCode}}</td>
      <td>{{maintenanceEventShortTermRental.opsNote}}</td>
      <td>{{maintenanceEventShortTermRental.createDate}}</td>
      <td><span style="float:none">
        <a>
          <i class="pi pi-pencil" aria-hidden="true"
            style="color:blue; font-size:110%; padding-right:20px;"
          (click)="onOpenFormEdit(maintenanceEventShortTermRental)"></i>
        </a>
      </span>
    </td>
  </tr>
}

@if (!maintenanceEventId) {
  <tr [pSelectableRow]="maintenanceEventShortTermRental">
    <td>{{maintenanceEventShortTermRental.shortTermRentalId}} </td>
    <td>{{maintenanceEventShortTermRental.propertyCode}}</td>
    <td>{{maintenanceEventShortTermRental.opsNote}}</td>
    <td>{{maintenanceEventShortTermRental.createDate}}</td>
    <td><span style="float:none">
      <a>
        <i class="pi pi-pencil" aria-hidden="true"
          style="color:blue; font-size:110%; padding-right:20px;"
        (click)="onOpenFormEdit(maintenanceEventShortTermRental)"></i>
      </a>
    </span>
  </td>
</tr>
}
</ng-template>
</p-table>